import Contratti from './Contratti';
export default Contratti;
